module.exports = __webpack_public_path__ + "static/img/payewm.308e3fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/payewm.png
// module id = HKVK
// module chunks = 2